/* unplugin-vue-components disabled */import { render } from "./manage.vue?vue&type=template&id=2d160792&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"

import "./manage.vue?vue&type=style&index=0&id=2d160792&scoped=true&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿英文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d160792"]])

export default __exports__